module.exports = __webpack_public_path__ + "f4757098510495b128fb61030a5af67b.png";